import { Link } from "react-router-dom";
import { HOME_CASE_SLUGS } from "@/site/caseSlugs";
import { useT, useLangPath } from "@/i18n";

/** Cardurile de proiect.
 *
 *  Structura vine dintr-o referință pe care a ales-o clientul: imaginea
 *  produsului sus, apoi categoria, numele, și trei rânduri etichetate —
 *  problema, soluția, rezultatul — apoi intrarea în caz.
 *
 *  Cele trei valori NU sunt text nou: sunt titlurile blocurilor care există
 *  deja pe pagina fiecărui caz (blocks[0] problema, blocks[1] abordarea,
 *  blocks[3] rezultatul). Un card care rezumă cazul cu propriile lui propoziții
 *  nu poate să devină neadevărat când se schimbă cazul.
 *
 *  Cardul are o suprafață proprie, foarte stinsă, și o muchie de tăiere
 *  deasupra. E singura excepție de la regula „un singur plan" din restul
 *  site-ului, și e deliberată: lucrările sunt singurul loc unde ceva trebuie
 *  să se ridice de pe pagină.
 *
 *  alt="" e deliberat: fiecare imagine stă într-un link care conține deja
 *  numele proiectului ca text. */
export default function WorkCards({ detailed = false }: { detailed?: boolean }) {
  const H = detailed ? "h2" : "h3";
  const t = useT();
  const lp = useLangPath();
  /* `detailed` înseamnă /work, unde secțiunea e pagina întreagă și le arată pe
     toate. Pe landing e o selecție de patru — filtrarea se face pe slug, nu pe
     poziție, ca ordinea din dicționar să rămână liberă. */
  const shown = detailed ? t.cases : t.cases.filter((c) => HOME_CASE_SLUGS.includes(c.slug));

  return (
    <div className="workgrid">
      {shown.map((c, i) => {
        const rows: Array<[string, string]> = [
          [t.workPage.task, c.blocks[0].h3],
          [t.workPage.solution, c.blocks[1].h3],
          [t.workPage.result, c.blocks[3].h3],
        ];
        return (
          <Link className="wcard" to={lp(`/work/${c.slug}`)} key={c.slug}>
            {/* Cazurile care sunt un site își descriu captura; cele cu model 3D
                rămân cu alt gol — randarea nu spune nimic ce nu scrie deja în
                card, iar un alt care repetă titlul e zgomot pentru cititorul de
                ecran. */}
            <span className="wshot">
              <img
                src={`/work/${c.slug}-1200.webp`}
                srcSet={`/work/${c.slug}-600.webp 600w, /work/${c.slug}-1200.webp 1200w`}
                sizes="(max-width:820px) 92vw, 560px"
                width={1200}
                height={750}
                alt={c.shotAlt ?? ""}
                loading={i < 2 ? "eager" : "lazy"}
                decoding="async"
              />
            </span>

            <div className="wbody">
              <span className="wcat">{c.meta[0].b ?? c.meta[0].t}</span>
              {/* Numele proiectului era un <span>: patru proiecte, niciun titlu.
                  Pe landing cardurile stau sub h2-ul „Selected work", deci h3;
                  pe /work stau sub h1-ul paginii, deci h2. */}
              <H className="wname">{c.title}</H>

              <span className="wrows">
                {rows.map(([lbl, val]) => (
                  <span className="wrow" key={lbl}>
                    <span className="wrowl">{lbl}</span>
                    <span className="wrowv">{val}</span>
                  </span>
                ))}
              </span>

              {detailed && (
                <span className="ls">
                  {c.chips.slice(0, 6).map((ch) => <span key={ch}>{ch}</span>)}
                </span>
              )}

              <span className="wopen act act-b act-sm">
                {t.workPage.open} <span aria-hidden="true">→</span>
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
